<template>
  <div v-pin="{padding: {top: 136}}" class="c-operation">
    <v-layout class="card app-bg" column justify-center align-center>
      <template v-if="isLogin && iscode">
        <v-flex v-if="this.code === '1001'||this.code === '2016' || this.code === '2017'">
          <v-btn class="card-btn" color="primary" outline large @click="check(1)">保费试算</v-btn>
        </v-flex>
        <v-flex class="mt-2">
          <v-btn v-if="channelId == 48||this.code !== '2016'" class="card-btn" color="primary" large @click="check(2)">投保</v-btn>
        </v-flex>
      </template>
      <template  v-else-if="this.code === '1074' && !isLogin">
        <v-flex class="mt-2">
          <v-btn class="card-btn" color="primary" large @click="check(3)">投保</v-btn>
        </v-flex>
      </template>
      <template v-else>
        <v-flex class="text">如需详细报价请咨询客服</v-flex>
        <v-flex class="mt-3">
          <table class="text2">
            <tr>
              <td>补充医疗客服：</td>
              <td>4006-234-345</td>
            </tr>
            <tr>
              <td>天津总部电话：</td>
              <td>4006-234-345</td>
            </tr>
            <tr>
              <td>北京分公司电话：</td>
              <td>4006-234-345</td>
            </tr>
            <tr>
              <td>陕西分公司电话：</td>
              <td>4006-234-345</td>
            </tr>
          </table>
        </v-flex>
        <v-flex class="mt-4">——————— 或 ———————</v-flex>
        <v-flex class="text2 mt-3">当地的易才分支机构</v-flex>
        <v-btn v-if="this.code === '2016' || this.code === '2017'" class="card-btn" color="primary" large
               @click="regSync =
        true">
            企业注册</v-btn>
      </template>
    </v-layout>
     <v-dialog v-model="regSync" persistent max-width="480px">
        <v-form ref="invoiceForm" lazy-validation class="invoice">
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>企业名称</label>
            <v-text-field
                v-model="form.companyName"
                :rules="rules.billHead"
                placeholder="请输入企业名称"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>统一社会信用代码</label>
            <v-text-field
                v-model="form.companyCode"
                :rules="rules.billNo"
                placeholder="请输入纳税人识别号"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>联系人</label>
            <v-text-field
                v-model="form.name"
                :rules="rules.cuscCode"
                placeholder="请输入联系人"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>电话</label>
            <v-text-field
                v-model="form.account"
                :rules="rules.appPhone"
                placeholder="请输入手机号"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>联系人邮箱</label>
            <v-text-field
                v-model="form.email"
                :rules="rules.email"
                placeholder="请输入email"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <div style="text-align:center">
            <v-btn color="primary" :loading="invoiceLoading" @click="sureReg">确认注册</v-btn>
            <v-btn color="primary" @click="regSync = false">关闭</v-btn>
        </div>
            <div style="position: relative;height: 20px;width: 95%">
                <div style="position: absolute; left: 30%;top: 7px">
                    <span>阅读并接受</span>
                    <router-link to="/information?tab=3" target="_blank">《隐私政策》</router-link>
                </div>
            </div>
        </v-form>
    </v-dialog>
  </div>
</template>

<script>
import validate from "@/assets/js/validate";
export default {
  data(){
    return{
      solo:true,
      invoiceLoading:false,
      regSync:false,
      form:{
        companyName:"",
        companyCode:"",
        name:"",
        account:"",
        email:"",
      },
      rules: {
        billHead: [(v) => !!v || "请输入企业名称"],
        billNo: [
          v => {
            return (
              validate.isUnifiedSocialCreditCode(v) ||
              "请输入正确的统一社会信用代码"
            );
          }
        ],
        cuscCode: [
          v => {
            if (!v) {
              return "请输入联系人姓名";
            }
            if (!validate.isChineseName(v)) {
              return "请输入联系人中文姓名";
            }
            return true;
          }
        ],
        appPhone: [
          v => {
            if (!v) {
              return "请输入联系电话";
            }
            if (!validate.isTelephone(v) && !validate.isMobilePhone(v)) {
              return "请输入正确的联系电话";
            }
            return true;
          }
        ],
        email: [
          v => {
            if (!v) {
              return "请输入联系邮箱";
            }
            if (!validate.isEmail(v)) {
              return "请输入正确的联系邮箱";
            }
            return true;
          }
        ],
      },
    }
  },
  props: {
    code: String
  },
  methods: {
    sureReg(){
      if (this.$refs.invoiceForm.validate()) {
        this.invoiceLoading = true
        // setTimeout(() => {
          //   this.invoiceLoading = false
          //   this.$message.success('申请已提交，审核后可投保')
          //   this.regSync = false
          // }, 2000);
          this.$axios.post("/app/api/heshunbao/doRegister", this.form).then(res => {
              this.invoiceLoading = false
              if (res.code == 200){
                  this.$message.success('申请已提交，审核后可投保')
                  this.regSync = false
              }else{
                  this.$message.error(res.message)
              }
          }).catch(error => {
              this.invoiceLoading = false;
              this.$message.error(error.message);
          })
      }
    },
    check(type) {
      if (type === 1) {
        if(this.code === '1001'){
          this.$router.push(`/plan/${this.code}`);
        }else if(this.code === '2017'){
            this.$router.push(`/aigPlanB/${this.code}`);
        }else{
          this.$router.push(`/aigPlan/${this.code}`);
        }
      } else if (type === 3) {
        this.$messageBox.alert("产品报备中");
      }else {
        this.insure();
      }
    },
    insure() {
      if (!this.isLogin) {
        this.$store.dispatch("callLogin");
        return false;
      }
      this.$router.push(`/insure/${this.code}`);
    }
  },
  computed:{
    iscode(){
      return ['1001','2016','1074','1075', '2017'].includes(this.code);
    },
    channelId(){
      if(localStorage.getItem('qihuibao-web-userInfo')){
        return JSON.parse(localStorage.getItem('qihuibao-web-userInfo')).channelId
      }else{
        return 0
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-operation {
  .card {
    padding: 30px 25px;
    margin-bottom: 20px;
    .card-btn {
      width: 280px;
    }
  }
}
.must-tap {
          color: red;
          margin-right: 3px;
        }
        .invoice{
    background-color: #fff;
    padding: 30px;
    .form-item{
        label{
            width: 125px;
        }
    }
}
</style>

